import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./attachment-manager.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./attachment-manager.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, Output } from "@angular/core";
import { FormBuilder, NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";
import { AttachmentManagerConstants } from "./shared/constants/attachment-manager.constant";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { SelectedApplicationService } from "../../services/selected-application/selected-application.service";
import { AttachmentManagerService } from "./shared/services/attachment-manager.service";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { AppControllerService } from "../../../app-controller.service";
let AttachmentManagerComponent = class AttachmentManagerComponent {
    formBuilder;
    selectedApplicationService;
    appController;
    attachmentManagerService;
    setSelectAttachmentRequired = true;
    componentType;
    attachmentType;
    jobId;
    stepMetaData;
    hideFilter;
    hideAdd = false;
    hideDelete = false;
    hideAddAttachmentButton = false;
    hideDeleteAttachmentButton = false;
    anonymousAccess = {
        anonymousDocumentAccess: false,
        anonymousCommentRequestAccess: false
    };
    projectCycleId;
    autoAddAllAttachments = false;
    deleteAttachmentFromServer = false;
    attachmentListFormCtrl = AttachmentManagerConstants.ATTACHMENT_LIST_FORM_CTRL;
    attachmentArrayCtrl = AttachmentManagerConstants.ATTACHMENT_ARRAY;
    attachmentManagerFormControl;
    attachmentManagerFormSubscription;
    anonymousAccessMessage = AttachmentManagerConstants.ANONYMOUS_ACCESS_MESSAGE;
    getAttachmentsSubscription;
    dataUpdated = new EventEmitter();
    get value() {
        return this.attachmentManagerFormControl.value;
    }
    set value(value) {
        this.onChange(value);
        this.onTouched();
    }
    constructor(formBuilder, selectedApplicationService, appController, attachmentManagerService) {
        this.formBuilder = formBuilder;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.attachmentManagerService = attachmentManagerService;
    }
    ngOnInit() {
        this.iniAttachmentManagerFormControl();
        this.attachmentManagerFormSubscription = this.attachmentManagerFormControl.valueChanges.subscribe((value) => {
            this.onChange(value);
            this.onTouched();
        });
        this.getAttachments();
    }
    getAttachments() {
        if (this.autoAddAllAttachments === true && this.hideFilter === true) {
            this.getAttachmentsSubscription = this.selectedApplicationService.getAttachmentsObservable(this.jobId, this.attachmentType ? this.attachmentType.toString() : null).subscribe({
                next: (result) => {
                    this.attachmentManagerService.clearAttachments();
                    result.value.forEach(a => {
                        this.attachmentManagerService.selectSavedAttachment(a);
                        this.dataUpdated.emit();
                    });
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage(this.componentType, error, CRUDOperation.Add);
                }
            });
        }
    }
    iniAttachmentManagerFormControl() {
        this.attachmentManagerFormControl = this.formBuilder.group({
            attachmentList: []
        });
    }
    onChange = () => {
    };
    onTouched = () => {
    };
    registerOnChange(fn) {
        this.onChange = fn;
    }
    writeValue(value) {
        if (value) {
            this.value = value;
        }
        if (value === null) {
            this.attachmentManagerFormControl.reset();
        }
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    validate(_) {
        return this.attachmentManagerFormControl.valid
            ? null
            : { profile: { valid: false } };
    }
    dateUpdated() {
        this.dataUpdated.emit();
    }
    static ctorParameters = () => [
        { type: FormBuilder },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: AttachmentManagerService }
    ];
    static propDecorators = {
        setSelectAttachmentRequired: [{ type: Input }],
        componentType: [{ type: Input }],
        attachmentType: [{ type: Input }],
        jobId: [{ type: Input }],
        stepMetaData: [{ type: Input }],
        hideFilter: [{ type: Input }],
        hideAdd: [{ type: Input }],
        hideDelete: [{ type: Input }],
        hideAddAttachmentButton: [{ type: Input }],
        hideDeleteAttachmentButton: [{ type: Input }],
        anonymousAccess: [{ type: Input }],
        projectCycleId: [{ type: Input }],
        autoAddAllAttachments: [{ type: Input }],
        deleteAttachmentFromServer: [{ type: Input }],
        dataUpdated: [{ type: Output }]
    };
};
AttachmentManagerComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-attachment-manager",
        template: __NG_CLI_RESOURCE__0,
        providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => AttachmentManagerComponent),
                multi: true,
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef(() => AttachmentManagerComponent),
                multi: true,
            },
        ],
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], AttachmentManagerComponent);
export { AttachmentManagerComponent };
